import { render, staticRenderFns } from "./ManpowerExecutiveDetails.vue?vue&type=template&id=73ae9777&"
import script from "./ManpowerExecutiveDetails.vue?vue&type=script&lang=js&"
export * from "./ManpowerExecutiveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports